import React from 'react';

import { Field, FieldProps } from '@rjsf/utils';
import { format } from 'date-fns';

import { DateTimePicker } from 'components';

import './DatePickerControl.scss';
import { readOnlyFromProps } from './utils';

export const DatePickerControl: Field = (props: FieldProps) => {
  return (
    <DateTimePicker
      value={props.formData}
      disabled={readOnlyFromProps(props as any)}
      onChange={(date) => props.onChange(format(date!, 'dd-MM-yyyy'))}
      name={props.name}
    />
  );
};
